import React from 'react';
import { useNavigate } from 'react-router-dom';
import './index.css';

function Policy() {
  const navigate = useNavigate();

  return (
    <div className="p-6 text-left md:pl-28 text-center md:text-left">
      <button onClick={() => navigate(-1)} className="text-black font-bold underline mb-4 flex items-center">
        <svg className="w-6 h-6 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 19l-7-7 7-7"></path>
        </svg>
        Return to Home
      </button>
      <h2 className="text-3xl font-extrabold mb-6">Privacy Policy</h2>
      <p className="mb-6 text-lg leading-relaxed">Effective Date: January 16, 2025</p>
      <p className="mb-6 text-lg leading-relaxed">
        <strong>A2B Worldwide</strong> ("we," "our," or "us") values your privacy and is committed to
        protecting your personal information. This policy outlines how we collect, use, and protect
        your data when you use our services through our website (
        <a href="https://www.a2bworldwide.com" className="text-blue-500">
          https://www.a2bworldwide.com
        </a>
        ) or mobile app.
      </p>

      <h3 className="text-2xl font-bold mb-4">1. What Information We Collect</h3>
      <ul className="mb-6 text-lg leading-relaxed list-disc list-inside">
        <li>
          <strong>Personal Information:</strong> Name, email, phone number, payment details, and
          pickup/drop-off locations.
        </li>
        <li>
          <strong>Technical Information:</strong> Device type, IP address, browser type, and usage
          data.
        </li>
        <li>
          <strong>Location Data:</strong> Real-time location data to improve service accuracy (with
          your consent).
        </li>
      </ul>

      <h3 className="text-2xl font-bold mb-4">2. How We Use Your Information</h3>
      <p className="mb-6 text-lg leading-relaxed">
        We use your information to:
        <ul className="list-disc list-inside">
          <li>Provide and improve our services.</li>
          <li>Process bookings and payments.</li>
          <li>Send service updates or promotions (if opted in).</li>
          <li>Comply with legal requirements.</li>
        </ul>
      </p>

      <h3 className="text-2xl font-bold mb-4">3. Sharing Your Information</h3>
      <p className="mb-6 text-lg leading-relaxed">
        We may share your data with:
        <ul className="list-disc list-inside">
          <li>
            <strong>Service Providers:</strong> To process payments, improve services, or perform
            analytics.
          </li>
          <li>
            <strong>Legal Authorities:</strong> When required by law.
          </li>
          <li>
            <strong>Business Partners:</strong> In case of mergers or acquisitions.
          </li>
        </ul>
        We do not sell your personal information.
      </p>

      <h3 className="text-2xl font-bold mb-4">4. Your Choices and Rights</h3>
      <p className="mb-6 text-lg leading-relaxed">
        <ul className="list-disc list-inside">
          <li>
            <strong>Access and Update:</strong> You can update your information by contacting us.
          </li>
          <li>
            <strong>Opt-Out:</strong> You may unsubscribe from promotional communications at any
            time.
          </li>
          <li>
            <strong>Location Data:</strong> Disable location tracking via your device settings.
          </li>
        </ul>
      </p>

      <h3 className="text-2xl font-bold mb-4">5. Data Security</h3>
      <p className="mb-6 text-lg leading-relaxed">
        We take reasonable measures to protect your information but cannot guarantee complete
        security.
      </p>

      <h3 className="text-2xl font-bold mb-4">6. Third-Party Links</h3>
      <p className="mb-6 text-lg leading-relaxed">
        Our services may link to third-party sites. We are not responsible for their privacy
        practices.
      </p>

      <h3 className="text-2xl font-bold mb-4">7. Changes to This Policy</h3>
      <p className="mb-6 text-lg leading-relaxed">
        We may update this policy. Changes will be posted on our website with a new effective date.
      </p>

      <h3 className="text-2xl font-bold mb-4">8. Contact Us</h3>
      <p className="mb-6 text-lg leading-relaxed">
        For questions or concerns, contact us at:
        <br />
        Email: info@a2bcorporatesedan.com
        <br />
        Phone: 855-351-LIMO (5466)
      </p>
      <p className="text-lg leading-relaxed">This Privacy Policy was last updated on January 16, 2025.</p>
    </div>
  );
}

export default Policy;
